/* eslint-disable no-return-await */
import {Repository} from './Repository'

export default {
  async getRevenueTable () {
    return await Repository.get(`/api/getRevenueTable`)
  },
  async getGrossMarginTable () {
    return await Repository.get(`/api/getGrossMarginTable`)
  },
  async getEbitdaMarginTable () {
    return await Repository.get(`/api/getEbitdaMarginTable`)
  },
  async getOperatingMarginTable () {
    return await Repository.get(`/api/getOperatingMarginTable`)
  },
  async getnetProfitMarginTable () {
    return await Repository.get(`/api/getnetProfitMarginTable`)
  },
  async getinterestCoverageRatioTable () {
    return await Repository.get(`/api/getinterestCoverageRatioTable`)
  },
  async getleverageRelativeToEBITDATable () {
    return await Repository.get(`/api/getleverageRelativeToEBITDATable`)
  },
  async getleverageRelativeToEquityTable () {
    return await Repository.get(`/api/getleverageRelativeToEquityTable`)
  },
  async gettangibleNetWorthCoverageTable () {
    return await Repository.get(`/api/gettangibleNetWorthCoverageTable`)
  },
  async getcurrentRatioTable () {
    return await Repository.get(`/api/getcurrentRatioTable`)
  },
  async getquickRatioTable () {
    return await Repository.get(`/api/getquickRatioTable`)
  },
  async getcurrentAssetsLiquidationTable () {
    return await Repository.get(`/api/getcurrentAssetsLiquidationTable`)
  },
  async getcashConversionCycleTable () {
    return await Repository.get(`/api/getcashConversionCycleTable`)
  },
  async getRatingAssessment () {
    return await Repository.get(`/api/getRatingAssessment`)
  },
  async getcombinedAssessment () {
    return await Repository.get(`/api/getcombinedAssessment`)
  },
  async getliquidityAssessment () {
    return await Repository.get(`/api/getliquidityAssessment`)
  },
  async getAssmentScale () {
    return await Repository.get(`/api/getAssmentScale`)
  },
  async postAssesment (postdata) {
    return await Repository.post('/api/saveAssesment', postdata)
  },
  async updateAssesment (postdata) {
    return await Repository.post('/api/updateAssesment', postdata)
  },
  async getAssesments (data) {
    let userID = data.user_id
    return await Repository.get('api/getAssesments/' + userID)
  },
  async getSingleAssesments (userdata) {
    return await Repository.post('api/getSingleAssesments/', userdata)
  },
  async editAssesment (userdata) {
    return await Repository.post('api/editAssesment', userdata)
  },
  async updateAssessmentCounter () {
    return await Repository.post('api/updateAssessmentCounter/')
  },
  async deleteFinancialAssessment (data) {
    return await Repository.post('api/deleteFinancialAssessment', data)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/assessmentRepository.js